import {Component, computed, contentChild, EventEmitter, Input, Output} from '@angular/core';
import {SearchObject} from "../../core/definitions/search-object";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {objectTypeToMatSymbol} from "../material-icons";
import {NgClass, NgTemplateOutlet} from "@angular/common";
import {RouterLink} from "@angular/router";
import {MatTooltipModule} from "@angular/material/tooltip";
import {FormsModule} from "@angular/forms";
import {
  SearchResultThumbnailImage
} from "../../object-search/search-view-full-v2/search-result-thumbnail/search-result-thumbnail-image";
import {RestrictedIndicatorComponent} from "../restricted-indicator/restricted-indicator.component";

@Component({
  selector: 'app-thumbnail-item',
  imports: [
    FormsModule,
    MatCheckbox,
    MatIcon,
    NgClass,
    NgTemplateOutlet,
    RouterLink,
    MatTooltipModule,
    TranslateModule,
    SearchResultThumbnailImage,
    RestrictedIndicatorComponent,
  ],
  host: {
    '[attr.tabindex]': '"-1"'
  },
  templateUrl: './thumbnail-item.component.html',
  styleUrl: './thumbnail-item.component.scss',
})
export class ThumbnailItemComponent {
  @Input() item: SearchObject;
  @Input() routerLink: any[] | null = null;
  @Input() queryParams: { [key: string]: any } | null = null;
  @Input() showPackageIndicator: boolean = false;
  @Input() isSelected: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() tooltipText: string = '';

  @Output() select = new EventEmitter<{ item: SearchObject; event: MouseEvent }>();
  @Output() click = new EventEmitter<{ item: SearchObject; event: MouseEvent }>();
  @Output() changed = new EventEmitter<{ item: SearchObject, event: MatCheckboxChange }>();

  indicatorContent = contentChild('[indicator]');
  hasIndicator = computed(() => !!this.indicatorContent());

  onItemClick(event: MouseEvent): void {
    this.click.emit({item: this.item, event});
  }

  onItemSelect(event: MouseEvent): void {
    this.select.emit({item: this.item, event});
  }

  onSelectedChange(event: MatCheckboxChange): void {
    this.changed.emit({item: this.item, event});
  }

  getMaterialSymbol(objectType: string) {
    return objectTypeToMatSymbol(objectType);
  }
}
